import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { nestApi } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const { data } = await nestApi.get("/rahe-portal/me");
      setUser(data);
    } catch {
      localStorage.removeItem("humrahe_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("humrahe_token");
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [fetchUser]);

  const login = (token, userData) => {
    localStorage.setItem("humrahe_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("humrahe_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
